<template>
  <div id="reset-password">
    <div class="basic-box">
      <div class="row">
        <div class="title col-12">{{$t('resetPassword.title')}}</div>
      </div>
      <div class="row">
        <base-input
          :placeHolder="$t('resetPassword.placeholder.password')"
          :type="'password'"
          @enter="resetPasswordClicked"
          @baseInputValue="passwordChanged($event)"
          :isInvalid="!isPasswordValid && password != null"
          :errorText="$t('resetPassword.password.errorText')"
          class="col-12"
        />
      </div>
      <div class="row">
        <base-button
          @click="resetPasswordClicked"
          :text="$t('resetPassword.login.buttonText')"
          class="col-12"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import RegistrationFormMixin from '@/components/shared/users/RegistrationFormMixin';

export default {
  name: 'ResetPasswordScreen',
  mixins: [RegistrationFormMixin],
  components: {
    BaseInput,
    BaseButton,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      resetPassword: 'users/resetPassword',
    }),
    resetPasswordClicked() {
      if (!this.isPasswordValid) {
        return;
      }
      this.resetPassword({
        password: this.password,
        passwordResetCode: this.$route.params.code,
      })
        .then(() => {
          // window.location.href = "/";
        })
        .catch(() => {
          this.$swal(
            this.$t('resetPassword.error.title'),
            this.$t('resetPassword.error.message'),
            'error',
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#reset-password {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  .basic-box {
    width: 60%;
  }
  .row {
    height: 70px;
  }
}
</style>
